export default function PaymentReceiptUidController(
    $scope,
    $q,
    $timeout,
    paymentService,
    Basket,
    Bookings,
    Users,
    CheckoutErrors,
    ENV,
    $rootScope
) {
    const notifications = {
        missingUidParam: {
            id: "missing-uid-param",
            type: "error",
            message: "Fejl i url",
        },
        uidNotFound: {
            id: "uid-not-found",
            type: "info",
            message:
                "Din betaling er muligvis allerede gennemført, da betalingslinket er udløbet. Hvis du er i tvivl, kan du altid logge ind og se din bestilling under Min Side.",
        },
        noBookingFound: {
            id: "no-booking-found",
            type: "error",
            message: "Din booking blev ikke fundet",
        },
        paymentGatewayDisabled: {
            id: "payment-gateway-disabled",
            type: "info",
            message: "Payment is disabled in this environment - " + ENV.type,
        },
    };

    $scope.bookingError = { error: false };

    $scope.notifications = notifications;
    $scope.notification = null;

    const url = new URL(window.location.href);
    const acceptUrl = url.searchParams.get("accepturl"); // callback from DIBS will include this param

    let uid = null;
    if (!acceptUrl) {
        // Direct (no Dibs)
        uid = url.searchParams.get("uid");
    } else {
        /**
         * DIBS CALLBACK EXAMPLE URL
         * http://localhost:8080/checkout/payment-receipt?currencynumber=208&authkey=1a69bba65e8b93dc9e18dfee78a443ac&amount=13500&accepturl=http:%2F%2Flocalhost:8080%2Fcheckout%2Fpayment-receipt%3Fuid%3Dc6d23fe2558141dca72230b258bb0a3d&test=1&orderid=78644&merchant=90234252&flexwin_cardlogosize=3&statuscode=5&uid=c6d23fe2558141dca72230b258bb0a3d&approvalcode=123456&transact=2948757985&uniqueoid=yes&cardnomask=XXXXXXXXXXXX0000&capturenow=yes&currency=208&md5key=37f45694b17db98fbe681fd9a2d1b910&callbackurl=https:%2F%2Fstaging.bookbyen.dk%2Fweb%2Fapi%2FBooking%2FHandlePaymentResult%2F&currencyalpha=DKK&cardprefix=510010&paytype=MC
         */

        const dibsAcceptUrl = new URL(acceptUrl);
        uid = dibsAcceptUrl.searchParams.get("uid");
    }

    if (!uid) {
        $scope.notification = notifications.missingUidParam;
    }

    Bookings.getByUid(uid).then(
        (res) => {
            const booking = res;

            if (!booking) {
                $scope.notification = notifications.noBookingFound;
            }

            $scope.bookingId = booking.id;

            getPaymentResults(booking);
        },
        (err) => {
            // console.log("NO UID");
            $scope.notification = notifications.uidNotFound;
        }
    );

    // const findBooking = (bookings, bookingId) => {
    //     return bookings.find((booking) => booking.id == bookingId);
    // };

    const getPaymentResults = (booking) => {
        $q.all({
            payment: paymentService.getPaymentResult(booking.id), // legacy // will also delete UID on booking
            // bookings: Users.getBookings(userId), // ApiV3
        }).then(
            (res) => {
                handleBookings(booking);
                handleApiPaymentResponse(res.payment, booking);
            },
            (err) => {
                $scope.bookingError = CheckoutErrors.getBookingError({
                    error: true,
                    type: "booking-payment-api-error",
                });
            }
        );
    };

    const handleApiPaymentResponse = function (payment, booking) {
        //result =  {"CardType":"*","OrderNumber":"18","PDFLink":null,"PaymentStatus":false,"PaymentStatusMessage":"","PayedAmount":200.0}

        $scope.payment = payment;

        if (payment.PaymentStatus) {
            // console.log('all good')
        } else {
            if (!payment.PaymentStatusMessage) {
                $scope.payment.PaymentStatusMessage =
                    "Din booking er ikke betalt endnu - betalings ID: " +
                    payment.OrderNumber;
            }
        }
    };

    const handleBookings = (booking) => {
        if (!booking.bookingPeriods.length) {
            $scope.bookingError = CheckoutErrors.getBookingError({
                error: true,
                type: "booking-expired",
            });
            return false;
        }

        $scope.booking = booking;

        $rootScope.$broadcast("booking-update-broadcast");

        $scope.displayPage = true;
    };
}
